module.exports = __webpack_public_path__ + "img/values-img-4.b2ce883c.svg";